module.exports = __webpack_public_path__ + "img/5-2.7eee214e.svg";